module.exports = __webpack_public_path__ + "static/media/gifRea2.22a30255.gif";